export default __webpack_public_path__ + "configureIcon-4xq.svg";